<p-dialog header="{{moduleName}} Settings" (onHide)="cancelSettings()" [(visible)]="displayColumnSettings"
  [style]="{width: '550px'}" [modal]="true" [baseZIndex]="10000" appendTo="body">
  <div class="p-grid" style="height: 400px;">
      <div class="p-col-12">
        <div class="card">
            <div *ngIf="showDiv.collists">
                <div class="p-d-flex">
                    <div>
                        <h6>List View Column Selection (Max {{maxColumn}}/{{totalAmtForList}})</h6>
                    </div>
                </div>
                <div class="">
                    <div>
                        <input type="text" class="inputStyle p-inputtext" pInputText placeholder="Search for fields"
                            [(ngModel)]="listSearchInput">
                    </div>
                    <div class="p-d-flex p-ai-center gap-1 p-mt-2 ml-custom">
                        <p-checkbox 
                                binary="true"
                                inputId="binary"
                                class="p-mr-2"
                                [(ngModel)]="isSelectAllSectionField"
                                (onChange)="enableAllSectionFields($event,tempCols,'listView')">
                        </p-checkbox>
                        <label for="binary"><strong>Select All Fields</strong></label>
                    </div>
                    <div cdkDropList [cdkDropListData]="tempCols" (cdkDropListDropped)="dropListSection($event, 'listViewSection')">
                        <ng-container *ngFor="let section of tempCols; let idx = index">
                            <div *ngIf="(section.fields | gblFilter: listSearchInput: 'name':'childFields')?.length>0" class="colList" cdkDrag (cdkDragStarted)="cdkDragStarted()"
                                (cdkDragReleased)="cdkDragReleased()">
                                <hr style="margin: 0;">
                                <div class="section-header">
                                    <h6 class="sectionLabel">
                                        <span (click)="toggleSection(section); $event.stopPropagation()">
                                            <i class="pi p-mr-3"
                                            [ngClass]="{'pi-minus': (!section?.isToogle || listSearchInput),'pi-plus': !(!section?.isToogle || listSearchInput)}">
                                            </i>
                                        </span>
                                        <span (click)="$event.stopPropagation()">
                                            <p-checkbox type="checkbox"
                                                        binary="true"
                                                        inputId="binary"
                                                        class="p-mr-1"
                                                        [disabled]="isSelectAllSectionField"
                                                        (onChange)="enableSectionFields($event,section,'listView',idx)">
                                            </p-checkbox>
                                        </span>
                                        <span (click)="toggleSection(section); $event.stopPropagation()">
                                            {{section.name}}
                                        </span>
                                    </h6>
                                </div>
                                <div *cdkDragPreview>
                                    <h6 class="sectionLabel p-pl-3" style="min-width: 200px;">{{section.name}}</h6>
                                </div>
                                <div *ngIf="(!section?.isToogle && showContent) || (listSearchInput && showContent)" class="sub-columns" cdkDropList
                                    [cdkDropListData]="section.fields" (cdkDropListDropped)="dropCol($event, 'listView', idx)">
                                    <ng-container
                                        *ngFor="let col of section.fields | gblFilter: listSearchInput:'name':'childFields'; let i = index">
                                        <div class="colList" cdkDrag
                                            [cdkDragDisabled]="!col.dragable"
                                            appendTo="body" *ngIf="col.name">
                                            <div class="p-d-flex">
                                                <i class="drag-icon fa fa-bars p-mt-1" *ngIf="col.dragable"></i>
                                                <i class="drag-icon fa fa-minus p-mt-1" *ngIf="!col.dragable"></i>
                                                <p-checkbox [(ngModel)]="col.enabled"
                                                    *ngIf="col?.childFields?.length === 0"
                                                    type="checkbox" binary="true" inputId="binary"
                                                    [disabled]="((!col.enabled && maxCheckedFieldForList) || (col?.columnName == 'businessName')) || (col.enabled && col?.columnName == 'taskId') || (col.enabled && col?.isDisabled) || (col.enabled && col?.columnName == 'sequenceNumber' && mergeAccountSequenceNumber && moduleId == 2) || ((disabledLabelNames.includes(col.columnName) || defaultDisabledColumns.includes(col.columnName)) && col.enabled)"
                                                    (onChange)="checkUncheckField($event.checked, col, 'listView', idx, 'parent')" class="p-mr-2">
                                                </p-checkbox>
                                                <span class="p-mt-1">{{col.name}}</span>
                                                <button type="button" pButton pRipple
                                                    class="expand-button p-button-text p-button-rounded p-button-plain p-ml-2"
                                                    [icon]="col.showChildrens ? 'pi pi-minus' : 'pi pi-plus'"
                                                    *ngIf="col.childFields.length > 0"
                                                    (click)="showChild(col)"></button>
                                            </div>
                                            <div
                                                *ngIf="col.childFields.length > 0 && (col.showChildrens || (listSearchInput && (col.childFields | gblFilter: listSearchInput:'name':'childFields')?.length>0))">
                                                <ul>
                                                    <li *ngFor="let childCol of col.childFields">
                                                        <p-checkbox [(ngModel)]="childCol.enabled" type="checkbox"
                                                            binary="true" inputId="binary"
                                                            [disabled]="((!childCol.enabled && maxCheckedFieldForList) || (childCol.enabled && childCol?.isDisabled) || (childCol.isRequired && childCol.enabled)) || (disabledLabelNames.includes(childCol.columnName) && childCol.enabled)"
                                                            (onChange)="checkUncheckField($event.checked, childCol, 'listView', idx, 'child', i, col)"
                                                            class="p-mr-2"></p-checkbox>
                                                        {{childCol.name}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                        </ng-container>
                    </div>

                </div>
            </div>
        </div>
      </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button (click)="cancelSettings()" label="Cancel" styleClass="p-button-secondary"></p-button>
    <p-button (click)="saveColumnSettings()"
    [disabled]="updateColumnSettingsData?.listViewFields?.length < 1 &&
                updateColumnSettingsData?.listViewSections?.length < 1 &&
                !detectStepBarOrDefaultViewChange" label="Save"></p-button>
  </ng-template>

</p-dialog>
